import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PolicyPopupRoutingModule } from './policy-popup-routing.module';
import { PolicyPopupComponent } from './policy-popup.component';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    PolicyPopupComponent
  ],
  imports: [
    CommonModule,
    PolicyPopupRoutingModule,
    MatIconModule,
  ],
  exports:[
    PolicyPopupComponent
  ]
})
export class PolicyPopupModule { }
